import { z } from 'zod'

/**
 * Caller-visible envelope status (spec). Prisma stores the same values in
 * SCREAMING_SNAKE — map at the API boundary.
 */
export const ENVELOPE_STATUSES = [
  'draft',
  'pending',
  'completed',
  'declined',
  'voided',
  'expired',
  'deleted',
] as const

export const envelopeStatusSchema = z.enum(ENVELOPE_STATUSES)

export type EnvelopeStatus = z.infer<typeof envelopeStatusSchema>

export const PRISMA_ENVELOPE_STATUSES = [
  'DRAFT',
  'PENDING',
  'COMPLETED',
  'DECLINED',
  'VOIDED',
  'EXPIRED',
  'DELETED',
] as const

export type PrismaEnvelopeStatus = (typeof PRISMA_ENVELOPE_STATUSES)[number]

export const ENVELOPE_STATUS_TO_PRISMA = {
  draft: 'DRAFT',
  pending: 'PENDING',
  completed: 'COMPLETED',
  declined: 'DECLINED',
  voided: 'VOIDED',
  expired: 'EXPIRED',
  deleted: 'DELETED',
} as const satisfies Record<EnvelopeStatus, PrismaEnvelopeStatus>

export const ENVELOPE_STATUS_FROM_PRISMA = {
  DRAFT: 'draft',
  PENDING: 'pending',
  COMPLETED: 'completed',
  DECLINED: 'declined',
  VOIDED: 'voided',
  EXPIRED: 'expired',
  DELETED: 'deleted',
} as const satisfies Record<PrismaEnvelopeStatus, EnvelopeStatus>
